import { GET_CAMPAIGNS_CATALOG, GET_CAMPAIGNS_CATALOG_SUCCESS, GET_CAMPAIGNS_CATALOG_ERROR, GET_CAMPAIGNS_CATALOG_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetCampaignsCatalog = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGNS_CATALOG:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGNS_CATALOG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_CAMPAIGNS_CATALOG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_CAMPAIGNS_CATALOG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetCampaignsCatalog;
